import React from "react";
import { motion, useScroll, useSpring } from "framer-motion";

/**
 * Thin Fina-orange progress bar pinned to the top of the viewport,
 * linked to the page's vertical scroll progress. Subtle but premium —
 * communicates "controlled, intentional reveal" as the user moves
 * through the story.
 */
export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 220,
    damping: 32,
    mass: 0.4,
  });

  return (
    <motion.div
      data-testid="scroll-progress"
      aria-hidden
      style={{ scaleX, transformOrigin: "0% 50%" }}
      className="fixed top-0 left-0 right-0 h-[2px] z-[60] pointer-events-none"
    >
      <span
        className="block w-full h-full"
        style={{
          background:
            "linear-gradient(90deg, transparent 0%, #FF5722 35%, #FF8A3C 65%, transparent 100%)",
          boxShadow: "0 0 12px rgba(255,87,34,0.55)",
        }}
      />
    </motion.div>
  );
};
